






















































import RentalSheet from "@/components/rental/RentalSheet.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import SelectAssignees from "@/components/utility/SelectAssignees.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { PartnerModule } from "@/store/modules/partner";
import CompanyMapDialog from "@/views/company/CompanyMapDialog.vue";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import ReportRentalCreateDialog from "./ReportRentalCreateDialog.vue";
import { IRental } from "@/models/rental.entity";

@Component({
  components: {
    MIconButton,
    MNoContent,
    CompanyMapDialog,
    MTextField,
    MSelect,
    SelectAssignees,
    RentalSheet,
    ReportRentalCreateDialog
  },
  filters: {}
})
export default class PartnerReportRentalCard extends mixins(PermissionMixin) {
  requestDialog = false;
  createDialog = false;
  editDialog = false;

  activeRental = 0;
  showPositions = false;
  showDocument = false;

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  removeFromReport(rental: IRental) {
    const index = this.report.rentals.indexOf(rental);
    if (index !== -1) {
      this.report.rentals.splice(index, 1);
    }
  }
}
